import { Star } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/modules/ui/components/tooltip/Tooltip';

interface CandidateScoreProps {
  score: number | null | undefined;
  size?: number;
}

const getStarColor = (score: number) => {
  if (score < 50) return 'var(--color-semantic-550)';
  if (score < 75) return 'var(--color-semantic-540)';
  return 'var(--color-semantic-560)';
};

const CandidateScore = ({ score, size = 14 }: CandidateScoreProps) => {
  if (score === null || score === undefined) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-sm font-medium text-neutral-500">—</span>
        </TooltipTrigger>
        <TooltipContent>Match score is not available yet</TooltipContent>
      </Tooltip>
    );
  }

  const rating = (score / 100) * 5;
  const displayRating = rating.toFixed(1);
  const color = getStarColor(score);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center gap-1">
          <span
            style={{
              color,
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            {displayRating}
          </span>
          <Star size={size} fill={color} color={color} strokeWidth={2} />
        </div>
      </TooltipTrigger>
      <TooltipContent>Match: {score}%</TooltipContent>
    </Tooltip>
  );
};

export default CandidateScore;
